import { FiscalYear } from 'models';

import isDateIntersectsWithFiscalYear from './isDateIntersectsWithFiscalYear';

export default function getCurrentFiscalYear(fiscalYearsList: FiscalYear[]) {
  let today = new Date();
  return (
    fiscalYearsList.find((fiscalYear) =>
      isDateIntersectsWithFiscalYear(today, fiscalYear)
    ) ?? null
  );
}
